import apiClient from '../apiClient';
import { POST_NOT_ALLOWED_COUNTRY_FOR_COMPANY_URL } from '../apiUrl';

const postAllowedForCompanyApi = data => {
  return apiClient.post(POST_NOT_ALLOWED_COUNTRY_FOR_COMPANY_URL, data);
};

export default postAllowedForCompanyApi;
